import { GREEN } from "@/lib/constants";

export function GooglePlayBadge() {
  return (
    <div
      className="flex items-center gap-3.5 rounded-2xl px-5 py-3 transition-colors"
      style={{
        // Dark-fixed like the official Google Play badge: green tint composited over a solid dark base
        background: "linear-gradient(rgba(91,140,255,0.1), rgba(91,140,255,0.1)), #0a0a0b",
        border: "1px solid rgba(91,140,255,0.2)",
      }}
    >
      <svg
        viewBox="0 0 24 24"
        className="size-7"
        style={{ color: GREEN }}
        fill="currentColor"
        aria-hidden
      >
        <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zM14.499 12.707l2.522 2.523-12.418 7.18 9.896-9.703zM4.603 1.59l12.418 7.18-2.522 2.523L4.603 1.59zM20.159 10.81c.69.398.69 1.382 0 1.78l-2.387 1.38L15.205 12l2.567-1.97 2.387 1.38z" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className="mb-0.5 text-[11px] text-[#a0a0a0]">Get It On</span>
        <span className="text-[18px] font-semibold tracking-tight text-white">Google Play</span>
      </div>
    </div>
  );
}
